// extracted by mini-css-extract-plugin
export default {"cls1":"PaperImages-cls1_EaT","cls2":"PaperImages-cls2_PYP PaperImages-cls1_EaT"};